module.exports = __webpack_public_path__ + "static/media/icon-play-large.ce4842d5.svg";